import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { Authenticate } from '../../models/authenticate';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-agree',
  templateUrl: './agree.html',
  styleUrls: ['./agree.css'],
  imports: [ReactiveFormsModule, CurrencyPipe, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class Agree implements OnInit {
  submitted = false;
  clicked = false;
  clickedOnce = false;
  changed = false;
  allStates: any = [];
  allCountries: any = [];
  claimantsInformation: FormGroup;
  submittedClaim: Claimant;
  au: Authenticate;
  response: string | undefined;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  showSubmittalErrorWarning: boolean = false;

  showDivProvince: boolean = false;
  showDivCityStateZip: boolean = true;
  selectedCountry: any;

  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private claimantService: ClaimantService) { }

  ngOnInit() {
    this.dateLoaded = new Date();
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.loadAllCountries();
    //this.selectedCountry = "United States";
    this.au = this.storage.retrieve('authenticatedUser');
    this.claimantsInformation = this.fb.group({
      noticeId: [this.au.noticeId],
      uniqueId: [this.au.uniqueId],
      purchaseNetTotal: [this.au.purchaseNetTotal],

      cargill2015: [this.au.cargill2015],
      cargill2016: [this.au.cargill2016],
      cargill2017: [this.au.cargill2017],
      cargill2018: [this.au.cargill2018],
      cargill2019: [this.au.cargill2019],
      cargill2020: [this.au.cargill2020],

      jbs2015: [this.au.jbs2015],
      jbs2016: [this.au.jbs2016],
      jbs2017: [this.au.jbs2017],
      jbs2018: [this.au.jbs2018],
      jbs2019: [this.au.jbs2019],
      jbs2020: [this.au.jbs2020],

      tyson2015: [this.au.tyson2015],
      tyson2016: [this.au.tyson2016],
      tyson2017: [this.au.tyson2017],
      tyson2018: [this.au.tyson2018],
      tyson2019: [this.au.tyson2019],
      tyson2020: [this.au.tyson2020],

      nationalBeef2015: [this.au.nationalBeef2015],
      nationalBeef2016: [this.au.nationalBeef2016],
      nationalBeef2017: [this.au.nationalBeef2017],
      nationalBeef2018: [this.au.nationalBeef2018],
      nationalBeef2019: [this.au.nationalBeef2019],
      nationalBeef2020: [this.au.nationalBeef2020],

      attention: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])],
      province: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      postalCode: ['', Validators.compose([Validators.maxLength(10)])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      filingType: ['Agree'],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      title: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],

    });
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      console.log(data);
      this.allCountries = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.claimantsInformation.controls; }

  getCountryValue($event) {
    this.changed = true;
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value !== 'United States') {
      this.showDivProvince = true;
      this.showDivCityStateZip = false;

      this.claimantsInformation.get('province').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('province').updateValueAndValidity();

      this.claimantsInformation.get('postalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.claimantsInformation.get('postalCode').updateValueAndValidity();

      this.claimantsInformation.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('city').updateValueAndValidity();
      this.claimantsInformation.get('city').reset();

      this.claimantsInformation.get('state').reset();
      this.claimantsInformation.get('state').clearValidators();
      this.claimantsInformation.get('state').updateValueAndValidity();
      this.claimantsInformation.get('zip').reset();
      this.claimantsInformation.get('zip').clearValidators();
      this.claimantsInformation.get('zip').updateValueAndValidity();
    }

    if ($event.target.value === 'United States') {
      /* */
      this.showDivProvince = false;
      this.showDivCityStateZip = true;
      this.claimantsInformation.get('state').setValidators(Validators.compose([Validators.required]));
      this.claimantsInformation.get('state').updateValueAndValidity();
      this.claimantsInformation.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.claimantsInformation.get('zip').updateValueAndValidity();
      this.claimantsInformation.get('city').reset();
      this.claimantsInformation.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('city').updateValueAndValidity();
      this.claimantsInformation.get('postalCode').reset();
      this.claimantsInformation.get('postalCode').clearValidators();
      this.claimantsInformation.get('postalCode').updateValueAndValidity();
      this.claimantsInformation.get('province').reset();
      this.claimantsInformation.get('province').clearValidators();
      this.claimantsInformation.get('province').updateValueAndValidity();
    }
  }

  getPhoneType2Value() {
    this.changed = true;
    const secondaryPhoneType = this.claimantsInformation.get('secondaryPhoneType')?.value;

    if (secondaryPhoneType !== '') {
      this.claimantsInformation.get('secondaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.claimantsInformation.get('secondaryPhone').clearValidators();
    }
    this.claimantsInformation.get('secondaryPhone').updateValueAndValidity();
  }

  onSubmit() {
    this.submitted = true;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();

    /*console.log(claimant);*/
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: Claimant) {
    const message = "Unable to save claimant data.";

    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.statusMessage === message) {
        this.showSubmittalErrorWarning = true;
        return;
      }
      this.storage.store('claimant', this.submittedClaim);
      // this.submitted = false;
      this.claimantsInformation.reset();
      this.spinner.hide();
      this.router.navigate(['/complete']);
    });
  }
}
